<template>
    <div>
        <label :for="'form_'+name" class="form-label">{{label}}</label>
        <select
            :id="'form_'+name"
            class="form-control"
            :class="{'is-invalid':hasError()}"
            :value="modelValue"
            @change="emitChange($event.target.value)"
        >
            <option v-for="option in options" :value="option.key">{{option.value}}</option>
        </select>
        <div v-html="feedbackHtml()"></div>
    </div>
</template>
<script>
    import SimpleFormElementMixin from "./SimpleFormElementMixin";
    export default {
        props : {
            modelValue : {type: String, required: false},
            options : {type: Object, required: true},
        },
        emits: ['onUpdate'],
        mixins: [SimpleFormElementMixin],
        methods: {
            emitChange(value) {
                this.$emit('update:modelValue', value)
                this.$emit('onUpdate', value)
            }
        }
    }
</script>
